import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import Alert from 'react-s-alert';
import { change, Field, reduxForm, reset } from 'redux-form';
import classNames from 'classnames';

import CurriculumLibrariesModal from './curriculumLibraries_Modal';
import { renderCheckBox, renderTextField } from '../../../components/reduxFields';
import { alertConfirmation, resetFiltersAndSorting, STAGINGQA, VIP } from '../../../actions/utilAction';
import SortingCustom from '../../../components/SortingCustom';
import { getCurriculumLibrariesList, deleteCurriculumLibraries, UpdateDCArchiveStatus } from './actions/CurriculumLibrariesActions';
import PaginatorCustom from '../../../components/paginationCustom';
import Domain from './components/domain/index'
import UploadCSVModal from './UploadCSVDocument_Modal';
import { CommonButton } from '../../../components/buttons';

const stylescss = {
    checkbox: {
      marginBottom: 16,
    },
  };

class ManageCurriculumLibraries extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            curriculumLibrariesId: null,
            isDomain: false,
            curriculumLibraryIdForDomain: null,
            libraryName: '',
            openUploadCSVDocument: false,
            uploadCSVDocumentObj: null,
            uploadCSVDocumentsForDCMessage: '',
            selectedLibraryIds: [],     
            ShowArchivedOnly : false,      
        }
        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        this.handleSearchCurriculumLibraries = this.handleSearchCurriculumLibraries.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
        this.CheckLibrary = this.CheckLibrary.bind(this);
        this.ResetAllCheckBoxes = this.ResetAllCheckBoxes.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.saved_curriculumLibraries && nextProps.saved_curriculumLibraries !== this.props.saved_curriculumLibraries) {
            this.loadData();
        }
        if (nextProps.deleted_curriculumLibraries && nextProps.deleted_curriculumLibraries !== this.props.deleted_curriculumLibraries) {
            this.loadData();
        }

        if (nextProps.uploadCSVDocumentsForDCMessage && this.props.uploadCSVDocumentsForDCMessage !== nextProps.uploadCSVDocumentsForDCMessage) {    
            let message = nextProps.uploadCSVDocumentsForDCMessage || '';     
            this.setState({ uploadCSVDocumentsForDCMessage: message });
        }

        if (nextProps.archiveBatchDCStatus && nextProps.archiveBatchDCStatus !== this.props.archiveBatchDCStatus) {
            this.setState({ selectedLibraryIds : [] },()=>{
                this.ResetAllCheckBoxes();
              this.loadData();
            });      
          }  
    }

    componentWillUnmount() {
        Alert.closeAll();
    }

    uploadDocumenthandler = () => {
        Alert.closeAll();
        this.setState({ openUploadCSVDocument: true, uploadCSVDocumentObj: null, uploadCSVDocumentsForDCMessage: '' });
      }
    
      handleCloseHandler = () => {
        this.setState({ openUploadCSVDocument: false });
      };

    loadData(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null, ShowArchivedOnly: this.state.ShowArchivedOnly ? '1' : '0',   },
            pageNumber: page_number || 1,
        };
        this.props.getCurriculumLibrariesList(searchObj);
    }

    handleOpen = () => {
        Alert.closeAll();
        this.setState({ open: true, curriculumLibrariesId: null, uploadCSVDocumentsForDCMessage: '' });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleSearchCurriculumLibraries() {
        return false;
    }

    handleSearchChange(event) {
        if (event.target.value.length > 2) {
            this.filter.searchText = event.target.value;
            this.loadData();
        } else if (event.target.value.length === 0) {
            this.filter.searchText = '';
            this.loadData();
        }
    }

    handleReset = () => {
        Alert.closeAll();
        this.props.dispatch(reset('ManageCurriculumLibrariesForm'));
        resetFiltersAndSorting(this.filter, 'id', true);
        this.filter.sort_Column = '';
        this.filter.sort_order = '';
        this.setState({ open: false, curriculumLibrariesId: null, uploadCSVDocumentsForDCMessage: '', ShowArchivedOnly : false  }, ()=>{this.loadData();});
        
    };

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_order = col_order;
            this.loadData();
        }
    }

    handleEditClick = (event, obj) => {
        Alert.closeAll();
        this.setState({ open: true, curriculumLibrariesId: obj.id });
    }

    handleAlertClick = (event, curriculumLibrariesId) => {
        this.props.deleteCurriculumLibraries(curriculumLibrariesId);
        Alert.closeAll();
    }

    handleDeleteClick = (event, obj) => {
        alertConfirmation('Are you sure you want to delete Curriculum Libraries details?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleAlertClick,
                id: obj.id,
            },
        });
    }

    onClickHandler = (e, obj) => {
        this.setState({
            curriculumLibraryIdForDomain: obj.id,
            isDomain: true,
            libraryName: obj.libraryName
        })
        this.loadData()
    }

    onBackClick = () => {
        this.setState({
            curriculumLibraryIdForDomain: null,
            isDomain: false,
            libraryName: ''
        })
        this.loadData();
    }

    handleAlertArchiveBatchLibrariesClick = (event) => {
        this.props.UpdateDCArchiveStatus(this.state.selectedLibraryIds.toString(), true, 'MasterLibrary');
        Alert.closeAll();
      }
    
      handleArchiveBatchLibrariesClick = (event) => {
        Alert.warning('Are you sure you want to archive selected libraries?', {
          position: 'bottom-right',
          effect: 'slide',
          timeout: 10000,
          customFields: {
            displayComponent: true,
            handleButtonClick: this.handleAlertArchiveBatchLibrariesClick,
            //id: obj.id,
          },
        });
      }

      handleAlertUnArchiveBatchLibrariesClick = (event) => {
        this.props.UpdateDCArchiveStatus(this.state.selectedLibraryIds.toString(), false, 'MasterLibrary');
        Alert.closeAll();
      }
    
      handleUnArchiveBatchLibrariesClick = (event) => {
        Alert.warning('Are you sure you want to unarchive selected libraries?', {
          position: 'bottom-right',
          effect: 'slide',
          timeout: 10000,
          customFields: {
            displayComponent: true,
            handleButtonClick: this.handleAlertUnArchiveBatchLibrariesClick,
            //id: obj.id,
          },
        });
      }

      ResetAllCheckBoxes()
      {
        this.props.curriculumLibrariesData != null && this.props.curriculumLibrariesData && this.props.curriculumLibrariesData.data.forEach((obj, Index) => {
            let idCheck = `Claims[${Index}].Chk`;                
            this.props.dispatch(change('ManageCurriculumLibrariesForm', idCheck, false));                
        });
      }

    CheckLibrary(e, index, data) {    
        let selectedLibraryIds = this.state.selectedLibraryIds;        
        let isChecked = e.target.checked;
        if (isChecked) {     
            selectedLibraryIds.push(data.id);              
        } else {     
            index = selectedLibraryIds.findIndex((value) => value === data.id);
            if (index >= 0) {
                selectedLibraryIds.splice(index, 1);         
            }      
        }
        this.setState({ selectedLibraryIds });
      }

      handleAdvanceFilterCheck = (input, name) => {
        this.setState({ [name]: input.target.checked },
          () => {
            this.loadData();
          });
      }

    renderData(curriculumLibrariesList) {
        curriculumLibrariesList = curriculumLibrariesList || [];
        if (!curriculumLibrariesList.length) {
            return (
                <tr>
                    <td colSpan="5">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return curriculumLibrariesList.map((Obj, index) => {
            return (
                <tr key={Obj.id}>
                    <td width="5%">
                        <div className="table_custom-check">
                        <Field
                            name={`Claims[${Obj.id}].Chk`}
                            component={renderCheckBox}
                            onChange={(e) => this.CheckLibrary(e, index, Obj)}
                            style={stylescss.checkbox}
                        />
                        </div>
                    </td>
                    <td>{Obj.libraryName}</td>
                    <td><a href="#" onClick={(e) => this.onClickHandler(e, Obj)}>View Targets/Goals</a></td>
                    <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Yes' : 'No'}</td>
                    {this.props.updatePermission || this.props.deletePermission ?
                        <td>
                            {this.props.updatePermission ?
                                <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                                : null
                            }
                            {this.props.deletePermission ?
                                <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                                : null
                            }
                        </td>
                        : null
                    }
                </tr>
            )
        })
    }

    curriculumLibrariesRender = () => {
        const { handleSubmit, curriculumLibrariesData } = this.props;
        let curriculumLibrariesList = (curriculumLibrariesData && curriculumLibrariesData.data) || [];
        let curriculumLibrariesMeta = (curriculumLibrariesData && curriculumLibrariesData.meta) || null
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        return (
            <div>
            <h2 className="page_title">Manage Curriculum Libraries</h2>
              {this.state.openUploadCSVDocument ? <UploadCSVModal  uploadCSVDocumentObj={this.state.uploadCSVDocumentObj} closeDialog={this.handleCloseHandler}  /> : ''}      
            <div className="clearfix"></div>
            <div className="readmin-panel">
                <div className="panel-body">
                    <div className="modalwindow">
                        <div className="row">
                            <div className="col-sm-12">
                                {this.props.addPermission ?
                                    <div>
                                        <RaisedButton label="Add Curriculum Library" primary={true} onTouchTap={this.handleOpen} />                                        
                                        <CommonButton className="soapmodal_btn ml-3" label="Upload Excel" primary={true} onTouchTap={this.uploadDocumenthandler} />                                        
                                        <CommonButton className={this.state.selectedLibraryIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedLibraryIds.length > 0 && !this.state.ShowArchivedOnly ? false : true} label="Mark as Archived" onTouchTap={(e) => this.handleArchiveBatchLibrariesClick(e)} />
                                        <CommonButton className={this.state.selectedLibraryIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedLibraryIds.length > 0 && this.state.ShowArchivedOnly ? false : true} label="Mark as Unarchived" onTouchTap={(e) => this.handleUnArchiveBatchLibrariesClick(e)} />
                                    </div>
                                    : null}
                            </div>
                        </div>
                        <div className="row mt-20">
                            <div className="col-sm-4 field-mr">
                                <Field
                                name="ShowArchivedOnly"
                                label="Show Archived Only"
                                component={renderCheckBox}
                                onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowArchivedOnly')}
                                />
                            </div>
                            <div className="col-sm-8">
                                <div className="row end-flex">
                                    <div className="col-sm-6 mtm-27">
                                        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchCurriculumLibraries)}>
                                            <Field
                                                name="curriculumLibraries"
                                                floatingLabelText="Search"
                                                maxLength='25'
                                                onChange={this.handleSearchChange}
                                                component={renderTextField}
                                            />
                                        </form>
                                    </div>
                                    <div className="reset-btn col-sm-3 btn_rt">
                                        <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.open && <CurriculumLibrariesModal curriculumLibrariesId={this.state.curriculumLibrariesId} closeDialog={this.handleClose} />}
                    </div>
                    
                    {this.state.uploadCSVDocumentsForDCMessage ?
                    (<div className="row">
                    <div className="col-sm-12">
                        <div className="del-cont">
                        <div className="alert-danger mt-10">{this.state.uploadCSVDocumentsForDCMessage || ''}</div>
                        </div>
                    </div>
                    </div>) : null}

                    <div className="row">
                        <div className="col-sm-12">
                            <div className="table-responsive mt-15">
                                <table className={tableClass}>
                                    <thead>
                                        <tr>
                                            <th width="5%"></th>
                                            <th width="30%"><SortingCustom noSort={!curriculumLibrariesList.length} setSortColumn={this.setSortColumn} columnName='libraryName' displayName='Name' /></th>
                                            <th width="40%">Target Goals</th>
                                            <th width="15%">Active</th>
                                            {this.props.updatePermission || this.props.deletePermission ?
                                                <th width="20%">Actions</th>
                                                : null
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderData(curriculumLibrariesList)}
                                    </tbody>
                                </table>
                                {curriculumLibrariesMeta && curriculumLibrariesMeta['totalPages'] ?
                                    <PaginatorCustom data={curriculumLibrariesMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }

    render() {
        return (
          this.state.isDomain == false 
          ?
          this.curriculumLibrariesRender()
          :
          <Domain
          curriculumLibraryIdForDomain={this.state.curriculumLibraryIdForDomain}  
          libraryName={this.state.libraryName}
          onBackClick={this.onBackClick}/>
        )
    }
}

ManageCurriculumLibraries = reduxForm({
    form: 'ManageCurriculumLibrariesForm',
})(ManageCurriculumLibraries);

function mapStateToProps(state) {

    // Start For Role Permission
    let userActionPermission = [];
    if (state.login.userPermission) {
        let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "MASTERS_DATA_COLLECTION");
        let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "MASTERS_DATA_COLLECTION_CURRICULUM_LIBRARIES_LIST" && obj.moduleId === userModulePermission[0].moduleId);
        userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_CURRICULUM_LIBRARIES_LIST_ADD")[0].permission : false;
    let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_CURRICULUM_LIBRARIES_LIST_UPDATE")[0].permission : false;
    let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_DATA_COLLECTION_CURRICULUM_LIBRARIES_LIST_DELETE")[0].permission : false;

    // End For Role Permission

    return {
        loading: state.curriculumLibraries.loading,
        curriculumLibrariesData: state.curriculumLibraries.curriculumLibrariesList,
        saved_curriculumLibraries: state.curriculumLibraries.saved_curriculumLibrariesList,
        deleted_curriculumLibraries: state.curriculumLibraries.deleted_curriculumLibrariesList,
        addPermission: addPermission, // For Role Permission
        updatePermission: updatePermission, // For Role Permission
        deletePermission: deletePermission, // For Role Permission
        agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
        uploadCSVDocumentsForDCMessage: state.curriculumLibraries.uploadCSVDocumentsForDCMessage,
        archiveBatchDCStatus: state.curriculumLibraries.archiveBatchDCStatus,    
    }
}

export default connect(mapStateToProps, { getCurriculumLibrariesList, deleteCurriculumLibraries, UpdateDCArchiveStatus })(ManageCurriculumLibraries);


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/index.js